module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr-ca":{"All Lifts":"Tous","OPEN":"OUVERTS"}}')
  delete Component.options._Ctor
}
